/* eslint-disable array-callback-return */
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";
import "./styles.css";
import SeparatorImage from "./icons/separator.svg";
import { SidebarContext } from "../../../contexts/SidebarContext";
import { FC, useContext } from "react";
import { getLocalStorageData } from "../../utils/localStorage";
import { getQueryParams } from "../../utils/information";
const ZsBreadcrumbs: FC = () => {
  const { routes, entity } = useContext(SidebarContext);
  const navigate = useNavigate();
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  // discard parent menu
  // const discardedItems = routes?.map((route: any) => {
  //   if (route?.children) return route?.name?.toUpperCase();
  // });
  // discardedItems?.push("DASHBOARD", "ID");
  const discardedItems = ["DASHBOARD", "ID"];

  // add query params ids (multiple)
  const index = pathnames.indexOf("id");
  if (index !== -1) {
    pathnames.splice(index + 1, 0, ...getQueryParams(location.search, "id"));
  }
  const Separator = () => {
    return (
      <img src={SeparatorImage} alt="Separator" className="separatorArrow" />
    );
  };
  let entityIndex = 0;

  return (
    <Breadcrumbs
      separator={Separator()}
      className="breadcrumbs breadcrumbsPadding"
    >
      {pathnames.length > 0 ? (
        <Link
          className="cursorPointer"
          color="inherit"
          onClick={() => navigate("/dashboard")}
        >
          <Typography variant="h3">Dashboard</Typography>
        </Link>
      ) : (
        <Typography variant="h3">Dashboard</Typography>
      )}
      {pathnames.map((name, index) => {
        if (!discardedItems?.includes(name?.toUpperCase())) {
          let routeTo: string;
          const newPaths = pathnames.slice(0, index + 1);

          const idIndex = newPaths.indexOf("id");
          if (idIndex > 0) {
            const search = location.search
              ?.split("&")
              ?.slice(0, index - (idIndex + 1) + 1);
            newPaths?.splice(idIndex + 1, search?.length);
            routeTo = `/${newPaths?.join("/")}${search?.join("&")}`;
          } else {
            routeTo = `/${newPaths.join("/")}`;
          }

          const isLast = index === pathnames.length - 1;
          const isNumeric = /^\d+$/.test(name);

          const component = isLast ? (
            <Link className="lastItem" color={"inherit"} key={name}>
              <Typography variant="h3">
                {isNumeric
                  ? getLocalStorageData("pageIds")?.[name] ?? name
                  : name === "create"
                  ? entity?.entityName ?? name
                  : name.replace(/-/g, " ")}
              </Typography>
            </Link>
          ) : (
            <Link
              variant="h3"
              color={"inherit"}
              className="cursorPointer"
              onClick={() => {
                navigate(routeTo);
              }}
              key={name}
            >
              <Typography variant="h3">
                {isNumeric
                  ? getLocalStorageData("pageIds")?.[name] ?? name
                  : name.replace(/-/g, " ")}
              </Typography>
            </Link>
          );
          if (isNumeric) {
            entityIndex = entityIndex + 1;
          }
          return component;
        } else {
          return null;
        }
      })}
    </Breadcrumbs>
  );
};

export default ZsBreadcrumbs;
